import type { ChampionId } from "../data/champions";
import { CHAMPIONS, TIER_COLORS } from "../data/champions";
import { getAbility, hasAbility } from "../units/abilities";
import { effectiveStatsForLevel } from "../units/UnitStats";

let el: HTMLDivElement | null = null;

function getEl(): HTMLDivElement {
  if (!el) {
    el = document.createElement("div");
    el.className = "champ-tooltip";
    el.style.display = "none";
    document.body.appendChild(el);
  }
  return el;
}

export function showChampionTooltip(champId: ChampionId, level: number, anchor: HTMLElement): void {
  const champ = CHAMPIONS[champId];
  const stats = effectiveStatsForLevel(champ, level, champ.levelGrowth);
  const tierColor = TIER_COLORS[champ.tier];

  let abilityHtml = "";
  if (champ.abilityId && hasAbility(champ.abilityId)) {
    const ability = getAbility(champ.abilityId);
    abilityHtml = `
      <div class="ct-divider"></div>
      <div class="ct-ability-name">${ability.displayName}</div>
      <div class="ct-ability-desc">${ability.description}</div>
      <div class="ct-ability-cd">Cooldown: ${champ.abilityCooldown} turns</div>`;
  }

  const tooltip = getEl();
  tooltip.innerHTML = `
    <div class="ct-header">
      <span class="ct-name" style="color:${tierColor}">${champ.displayName}</span>
      <span class="ct-tier" style="color:${tierColor}">${champ.tier.toUpperCase()}</span>
    </div>
    <div class="ct-level">Level ${level}</div>
    <div class="ct-stats">
      <span class="ct-stat"><span class="ct-sl">HP</span> ${stats.maxHp}</span>
      <span class="ct-stat"><span class="ct-sl">AD</span> ${stats.ad}</span>
      <span class="ct-stat"><span class="ct-sl">AP</span> ${stats.ap}</span>
      <span class="ct-stat"><span class="ct-sl">RNG</span> ${stats.range}</span>
      <span class="ct-stat"><span class="ct-sl">AS</span> ${stats.attackSpeed.toFixed(2)}</span>
    </div>${abilityHtml}`;

  tooltip.style.visibility = "hidden";
  tooltip.style.display = "block";

  const anchorRect = anchor.getBoundingClientRect();
  const tipRect = tooltip.getBoundingClientRect();

  let top = anchorRect.bottom + 6;
  let left = anchorRect.left;

  if (left + tipRect.width > window.innerWidth - 8) left = window.innerWidth - tipRect.width - 8;
  if (left < 8) left = 8;
  if (top + tipRect.height > window.innerHeight - 8) top = anchorRect.top - tipRect.height - 6;

  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top}px`;
  tooltip.style.visibility = "visible";
}

export function hideChampionTooltip(): void {
  if (el) el.style.display = "none";
}
